module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp23_6005.ee3deced.png";